import Images from "../assets/images/Images";
import { getDomain, getRedirectEnv } from "../services/Utils";

const Header = () => {

  const secondBanner = {
    fontFamily: "GlacialIndifference !important",
    textAlign: "center",
    backgroundColor: "#366898",
    color: "white",
    fontSize: "1.5em",
    letterSpacing: "3px",
    minHeight: "64px",
  }

  const checkLogout = () => {
    window.location = getDomain();
  }

  return (
    <>
      <header className="second-banner" style={secondBanner}>
        <div style={{ width: "97%", height: "100%", textAlign: "center", backgroundColor: "#366898" }}>
          <div style={{ display: "flex", justifyContent: "space-between", height: "100%", paddingBottom: "10px" }}>
            <div style={{ width: "7em", minWidth: "7em", textAlign: "right", paddingTop: "0.15em", display: "flex" }}>
              <button style={{ backgroundColor: 'transparent', border: 'none' }}>
                <img alt="Cure Logo" style={{ width: "100%", cursor: "pointer", filter: 'brightness(0) invert(1)' }} src={Images.cureLogo} onClick={() => window.location.href = `${getDomain()}`}/>
              </button>
            </div>

            <div style={{ textAlign: "right", fontSize: "0.8em", display: "flex", justifyContent: "center", alignItems: "center" }}>
              <span className="span-header-phone">
                <a className="header-phone" style={{ color: "white", textDecoration: "none", textWrap: "nowrap"}} href="tel:8005352873">{"800-535-CURE(2873)"}</a>
              </span>
            </div>

          </div>
        </div>
      </header>
    </>
  )
}


export default Header;
